import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

export default () => {
  const location = useLocation()
  const [customHtml, setCustomHtml] = useState(undefined)

  useEffect(() => {
    const { pathname } = location
    axios.post('/api/custom-html', { pathname: pathname.substring(1) }).then((response) => {
      setCustomHtml(response.data)
    })
  }, [location])
  return (
    <div
      className="py-3 px-3 bg-white rounded shadow overflow-hidden"
      dangerouslySetInnerHTML={{ __html: customHtml }}
    />
  )
}
